import React from 'react';
import RadioGroup from '@nib-components/radio-group';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS, FUNNELS } from '../../util/constants';
const LABELS = {
  ARHI: DEFAULT_LABELS.STUDENT_DEPENDANT
};
const StudentDependant = props => {
  const {
    funnel = FUNNELS.ARHI,
    width = 20,
    optional = false,
    inline = true,
    options = {
      yes: 'Yes',
      no: 'No'
    },
    required
  } = props;
  return React.createElement(BaseFormField, {
    required: required,
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    optional: optional
  }, React.createElement(RadioGroup, {
    inline: inline,
    options: options
  }));
};
const StudentDependantWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(StudentDependant, {
  ...props
}));
export default StudentDependantWithFunnel;